<template>
  <div class="club-page anniversary-logo">
    <section>
      <div class="first">
        <img src="@/assets/img/club/mascot_1.png" alt="">
      </div>
    </section>
    <section>
        <p class="title">철룡 Steel dragon</p>
        <pre>승리를 위해 업그레이드되어 돌아왔습니다. 강력해진 눈빛과 화려한 뿔로 승리를 향해 질주 하겠습 니다. 한국프로축구를 더 뜨겁게 만들 철룡이를 기대해주세요!

용광로의 기운으로 새롭게 태어난 불꽃 슈터 철룡 광양 드래곤 던전에 승리의 수호자로 돌아오다! 언제나 전남 드래곤즈의 승리를 갈망했던 철룡은 어느 날 경기장에 찾아온 작은 불꽃들에 이끌려 그들이 향하는 곳으로 자취를 감추게 된다.

이윽고 불꽃들을 따라 도착한 곳은 바로 광양을 지키고 있는 제철소 안 용광로. 웅장한 용광로는 철 룡의 간절한 소원을 알고 있다는 듯이 나지막한 목소리로 철룡에게 말을 건넸다.

“네가 그토록 바랬던 승리의 소원을 들어줄게”

이윽고 불꽃들은 용광로의 기운을 받아 철룡의 몸을 감싸면서 불같은 강력한 힘과 신체 능력을 철룡 에게 불어넣어 다시 태어나게 했으며,철룡의 여의주를 통해 신 급의 지략을 선사할 새로운 수호자를 함께 선사하게 된다.

이렇게 더욱 강력한 모습으로 경기장에 등장한 철룡은 광양 드래곤 던전의 축구 역사를 새롭게 다시 만들고자 한다!
        </pre>
      <div class="logo-div">
        <img src="@/assets/img/club/mascot_5.png" alt="">
      </div>
    </section>

    <section>
      <p class="title">주주 Ju Ju</p>
      <pre>철룡의 여의주에서 전남드래곤즈 승리의 수호신으로! 소원을 들어주는 여의주의 희망처럼,전남드래 곤즈의 승리를 이끌겠습니다.

철룡의 여의주에서 태어난 이 몸, 전남드래곤즈의 승리를 이끌어주겠어!

축구계의 신동으로 태어났지만 인간계를 뛰어 넘는 신 급 능력에 여의주에 봉인된 주주는 철룡의 간 절한 희망과 용광로의 허락으로 봉인이 해제 된다.

봉인 해제된 주주는 철룡의 변화된 모습과 자신의 오랜 시간 축적된 방대한 전술 데이터와 AI를 능가하는 전략이라면 철룡의 오랜 염원인 승리가 가능하다는 판단으로 철룡이에게 제안한다.

“우리가 있어야 할 곳으로 돌아가자”

이윽고 용광로의 불꽃들과 함께 드래곤 던전으로 향하며,전남드래곤즈의 수호신이자 조력자로 새로운 승리를 다짐한다.</pre>
      <div class="logo-div">
        <img src="@/assets/img/club/mascot_2.png" alt="">
      </div>
    </section>

    <section>
      <div class="first">
        <img src="@/assets/img/club/mascot_3.png" alt="">
      </div>
    </section>
    <section>
      <div class="logo-div">
        <img src="@/assets/img/club/mascot_4.png" alt="dragons30">
        <div class="download-div">
          <button class="ai-btn" @click="downloadFile('mascot_ai_2023.zip')">AI 다운로드</button>
          <button class="jpg-btn" @click="downloadFile('mascot_png_2023.zip')">JPG 다운로드</button>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import {downloadFile} from '@/lib';

export default {
  name: 'Mascot',
  methods: {
    downloadFile
  }
}
</script>
